import { isEmptyString } from '@frontend-libs/base-package'
import { getSearchParamsFromObject } from '@frontend-libs/search-params-helper'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import { toast } from 'react-toastify'
import { v4 as uuid } from 'uuid'
import { type EventDTO, EventDTOScheme } from '~entities/index'
import { getInstance } from '~sharedApi/main'
import { API_DATE_FORMAT } from '~sharedConfig'

import {
	ApiCacheTimeMode,
	ApiRetryMode,
	ApiSourceType,
	getBaseApiConfigValue,
	QueryKeyName,
	type UseControllerQueryApi
} from '~sharedLib'

const { cache, retry } = getBaseApiConfigValue({
	cacheTimeMode: ApiCacheTimeMode.CacheFirstLong,
	retryMode: ApiRetryMode.BaseGet
})

type Variables = {
	from: string
	to: string
}
type Data = {
	items: EventDTO[]
	searchData: Variables
}
const errorId = uuid()

export const useControllerSecondSourceEventsApi: UseControllerQueryApi<Variables, Data, unknown> = (
	params,
	enabled = true
) => {
	const query = useQuery<Data, unknown>({
		queryFn: async () => {
			const response = await getInstance(ApiSourceType.Second).get(
				`announce${
					getSearchParamsFromObject({
						...params,
						from: format(params.from, API_DATE_FORMAT),
						to: format(params.to, API_DATE_FORMAT)
					})
				}`,
				{ maxRedirects: 0 }
			)
			if (response.status === 200) {
				const checkedResult = EventDTOScheme.array().safeParse(response.data)
				if (!checkedResult.success) {
					toast.error('Возникла ошибка при чтении данных', { toastId: errorId })
					throw checkedResult.error
				}

				return { items: checkedResult.data, searchData: params }
			}
			toast.error('Возникла ошибка при получении данных', { toastId: errorId })
			throw response.status
		},
		...cache,
		...retry,
		enabled: enabled && !isEmptyString(params.from) && !isEmptyString(params.to),
		placeholderData: keepPreviousData,
		queryKey: [QueryKeyName.SecondSourceEvents, params]
	})

	return query
}
